export default "__VITE_ASSET__Caia5YuS__"